import { render, staticRenderFns } from "./h-bank-form.vue?vue&type=template&id=3657167c&"
import script from "./h-bank-form.vue?vue&type=script&lang=js&"
export * from "./h-bank-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports